import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import {NsFeaturedProductsTranslations} from './ns-featured-products-translations.js';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@polymer/iron-ajax/iron-ajax.js';
import template from './ns-featured-products.html';
import {RunConfigService, ConfigService} from '@nuskin/ns-util';

/**
 * <h5>Note: A ticket is in place to rework this component</h5>
 * This is the Featured Products Component. Displays a carousel of products.
 *
 * <br>
 *
 * <section>
 *  <h2>Content Guidelines</h2>
 *  <p>Here are some guidelines on how to properly use this element.</p>
 * </section>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-featured-products></ns-featured-products>
 *   </template>
 * </demo-snippet>
 */
export class NsFeaturedProducts extends PolymerElement {

  static get template() {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get is() {
    return 'ns-featured-products';
  }

  static get properties () {
    return {
      language: {
        type: String
      }
    };
  }

  ready() {
    super.ready();
    this.requestHeaders = {
      "Accept": "application/json", 
      "Access-Control-Allow-Origin":"*, text/plain, */*", 
      "Accept-Language": "en-US,en;q=0.5", 
      "client_id": ConfigService.getMarketConfig().checkout.clientId, 
      "client_secret": ConfigService.getMarketConfig().checkout.clientSecret
    };
    this.requestUrl = `${aem.nuskin.configuration.siteUrl}/content/configuration/adrCarouselProducts/pointsProducts/${RunConfigService.getRunConfig().country}.jsons`;
    this.$.fetchFeaturedSkus.generateRequest();
    this.language = this.language || RunConfigService.getRunConfig().language || 'en';
    this.header = NsFeaturedProductsTranslations[this.language].header;
  }

  constructor() {
    super();
  }

  _handleResponse(data) {
    const skus = data.detail.response[0].skus;
    if(skus) {
      this.arrayOfFeaturedSkus = skus;
    }
  }
}

customElements.define(NsFeaturedProducts.is, NsFeaturedProducts);
